import React from 'react';
import ReactDOM from 'react-dom';
import * as firebase from "firebase";
import './index.css';
import App from './App';
var fb_config = require("./fb-sandbox.json");

firebase.initializeApp(fb_config);
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js